import { Card, Form } from "antd";
import { useAppSelector } from "../../../../app/store";
import { underscoreToCapitalizeString } from "../../../../utils/utils";
import EmailIcon from "../_icons/EmailIcon";
import MobileIcon from "../_icons/MobileIcon";
import UserIcon from "../_icons/UserIcon";
import UploadProfileImage from "./UploadProfileImage";

export default function UserInfo() {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {};
  const { user } = useAppSelector((state) => state.auth);

  return (
    <>
      <Card>
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <Form.Item className="mb-4 flex justify-center">
            <UploadProfileImage img={user?.profile?.pro_pic} />
          </Form.Item>
        </Form>
        <div>
          <h3 className="font-medium text-[#5E718D] text-center text-sm mb-3">
            {user?.name} <br /> (
            {underscoreToCapitalizeString(user?.role || "-")})
          </h3>
        </div>

        <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3 pb-3">
          <div>
            <UserIcon />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">User ID</h6>
            <h3 className="text-base text-[#5E718D] font-medium">{user?.id}</h3>
          </div>
        </div>

        <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3 pb-3">
          <div>
            <MobileIcon />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">
              Mobile Number
            </h6>
            <h3 className="text-base text-[#5E718D] font-medium">
              {user?.mobile || "N/A"}
            </h3>
          </div>
        </div>

        <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3">
          <div>
            <EmailIcon />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">
              Email Address
            </h6>
            <h3 className="text-base text-[#5E718D] font-medium">
              {user?.email}
            </h3>
          </div>
        </div>
      </Card>
    </>
  );
}
